import { store } from '@betacrew/jars-flux'
import { W9_MODALS_LOADING_STATES } from './constants';

export const componentKey = "RECIPIENT/W9_REQUESTS"

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {

        setFirstConfirmationModalOpen: (state, action) => {
            state.first_confirmationModalOpen = action.payload
        },

        setSecondRequestedCountModalOpen: (state, action) => {
            state.second_requestedCountModalOpen = action.payload
        },

        setThirdProceedWithW9RequestModalOpen: (state, action) => {
            state.third_proceedWithW9RequestModalOpen = action.payload
        },

        setRequestedCount: (state, action) => {
            state.requestedCount = action.payload
        },

        setIsDisplayPlansView: (state, action) => {
            state.displayPlansView = action.payload
        },

        setPrepayRequestFieldsTouch: (state, action) => {
            state.prepayRequestsInformation.allRequiredFieldsTouched = action.payload
        },

        setPrepayRequestModalOpen: (state, action) => {
            state.prepayRequestModalOpen = action.payload
        },

        setPayWithPrepayModalOpen: (state, action) => {
            state.payWithPrepayModalOpen = action.payload
        },

        setPayWithPaymentModalOpen: (state, action) => {
            state.payWithPaymentModalOpen = action.payload
        },

        setEstimedTaxModalOpen: (state, action) => {
            state.estimedTaxModalOpen = action.payload
        },

        setPrepayRequests: (state, action) => {
            let prepayRequestsInformation = { ...state.prepayRequestsInformation };

            Object.entries(action.payload).map(([key, value]) => {
                prepayRequestsInformation = {
                    ...state.prepayRequestsInformation,
                    [key]: {
                        ...state.prepayRequestsInformation[key],
                        ...value
                    },
                };

                state.prepayRequestsInformation = prepayRequestsInformation;
            })
        },

        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setBuyingPlan: (state, action) => {
            state.buyingPlan = action.payload;
        },

        setW9Fees: (state, action) => {
            state.w9Fees = action.payload;
        },

        setIsSelectAll: (state, action) => {
            state.isSelectAll = action.payload;
        },

        setHasEnoughRequests: (state, action) => {
            state.hasEnoughRequests = action.payload;
        },
        setShowUpdateRecipientEmailModal: (state, action) => {
            state.showUpdateRecipientEmailModal = action.payload
        },
        setRecipientEmail: (state, action) => {
            state.RecipientEmail = { ...state.RecipientEmail, ...action.payload }
        },
        setShowContactUsModal: (state, action) => {
            state.showContactUsModal = action.payload;
        }
    },
    initialReducerState: {
        loadingState: { state: W9_MODALS_LOADING_STATES.DISPLAY_PLANS_VIEW_READY },

        // w9 modals
        first_confirmationModalOpen: false,
        second_requestedCountModalOpen: false,
        third_proceedWithW9RequestModalOpen: false,
        prepayRequestModalOpen: false,
        payWithPrepayModalOpen: false,
        payWithPaymentModalOpen: false,
        estimedTaxModalOpen: false,

        displayPlansView: false,

        requestedCount: {
            bulkW9Requests: 0,
            AcceptedW9Requests: 0
        },

        paymentInformation: {},

        prepayRequestsInformation: {
            allRequiredFieldsTouched: false,

            prepayRequests: {
                label: "",
                value: "",
                errors: {},
                rules: { required: true }
            }
        },

        buyingPlan: false,
        w9Fees: 0,
        isSelectAll: false,
        hasEnoughRequests: false,
        
        showUpdateRecipientEmailModal: false,
        RecipientEmail: {
            value: "",
            errors: {},
            rules: { required: true, regex: { pattern: /^\S+@\S+\.\S+$/, message: "Please enter a valid email address" } }
        },
        showContactUsModal: false,
    }
});

export const { setFirstConfirmationModalOpen, setRequestedCount, setSecondRequestedCountModalOpen, setIsDisplayPlansView, setThirdProceedWithW9RequestModalOpen, setPrepayRequests, setPrepayRequestFieldsTouch, setPrepayRequestModalOpen, setPayWithPrepayModalOpen, setPayWithPaymentModalOpen, setEstimedTaxModalOpen, setLoadingState, setBuyingPlan, setW9Fees, setIsSelectAll, setHasEnoughRequests, setShowUpdateRecipientEmailModal, setRecipientEmail, setShowContactUsModal } = actions;
